import { Text, View } from '@react-pdf/renderer'
import PDFPage from '@/components/ReportPDF/PDFPage'

const toc = [
  { label: '第一章 本文件資訊之揭露與限制', key: 'chap1' },
  { label: '第二章 執行摘要', key: 'chap2' },
  { label: '第三章 受訓成果報告', key: 'chap3' },
  { label: '附件一 訓練名單', key: 'attach1' },
  { label: '附件二 未完成訓練名單', key: 'attach2' },
]

const ToCItem = ({ name, label, page, pageData, labelStyle, subItems }) => (
  <>
    <View
      style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end', marginBottom: 10 }}
    >
      <Text style={{ fontWeight: 'bold', ...labelStyle }}>{label}</Text>
      <View
        style={{
          flex: 1,
          height: 1,
          borderBottom: '2px solid black',
          borderStyle: 'dotted',
          marginHorizontal: 5,
          marginBottom: 3,
        }}
      />
      <Text>{page - 1}</Text>
    </View>

    {subItems && (
      <View style={{ paddingLeft: 20 }}>
        {subItems.map(({ key, ...itemProps }, index) => (
          <ToCItem
            key={`${name}_${index + 1}`}
            name={`${name}_${index + 1}`}
            labelStyle={{ fontWeight: 'normal' }}
            page={pageData[key] || 0}
            pageData={pageData}
            {...itemProps}
          />
        ))}
      </View>
    )}
  </>
)

const TableOfContentsPage = ({ pageData, reportData }) => (
  <PDFPage title="目錄" reportData={reportData} hideTitleDivider>
    {toc.map(({ key, ...tocProps }, index) => (
      <ToCItem
        key={`toc_${index + 1}`}
        name={`toc_${index + 1}`}
        page={pageData[key] || 0}
        pageData={pageData}
        {...tocProps}
      />
    ))}
  </PDFPage>
)

export default TableOfContentsPage
